/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable sonarjs/no-duplicate-string */
import React, { FC } from 'react'
import LayoutDefault from '@/components/layouts/Layout'
import SectionHeaderService from '@/components/modules/SectionHeaderService'
import TitleShadow from '@/components/modules/TitleShadow'
import Benefit from '@/components/modules/Benefit'
import ListBullet from '@/components/modules/ListBullet'
import ServiceItem from '@/components/modules/ServiceItem'
import PortfolioItem from '@/components/modules/PortfolioItem'
import WarrantyItem from '@/components/modules/WarrantyItem'
import ServiceGetInTouch from '@/components/modules/ServiceGetInTouch'
import Button from '@/components/elements/Button'
import ImgResponsive from '@/components/elements/ImgResponsive'
import Router from 'next/router'
import { FaArrowRight } from 'react-icons/fa'
import Link from 'next/link'

const ServicePage: FC = () => {
  return (
    <LayoutDefault>
      <SectionHeaderService
        bgColors='#FF7D7D'
        bgImage='/images/service/Twin_Service_Ecommerce.webp'
        bgImageMd='/images/service/Twin_Service_Ecommerce.webp'
        bgImageSm='/images/service/Twin_Service_Ecommerce.webp'
        title={<>&quot;จงผสานนวัตกรรมที่ทันสมัยไปกับการดำเนินธุรกิจของคุณ&quot;</>}
        description='"Synergizing​ innovation for your business journey"'
        bgImageWidth={1214}
        bgImageHeight={534}
        btnText='Start Project'
        onClick={() => Router.push('/contact-service')}
        prologue='แบบตามสั่ง'
        colorPrologue='rgba(0,0,0,.08)'
        titleShadow='ซอฟต์แวร์แบบตามสั่ง'
        colorTitleShadow='#000000'
        align='center'
        content={
          <>
            <p className='text-center'>
              ซอฟต์แวร์แบบตามสั่ง (Custom Software)
              คืออีกหนึ่งปัจจัยสำคัญที่จะเป็นตัวช่วยผลักดันให้ธุรกิจของคุณเติบโตและมีเสถียรภาพ หลาย
              ๆ
              ธุรกิจที่ประสบความสำเร็จมาจากการนำซอฟต์แวร์เข้ามาใช้ในการบริหารจัดการในการดำเนินธุรกิจ
              แบบ High Technology High Growth
              และถึงแม้ปัจจุบันจะมีซอฟต์แวร์แบบสำเร็จให้เลือกใช้มากมาย
              แต่ก็ใช่ว่าจะเหมาะสมกับทุกธุรกิจ
              ดังนั้นการพัฒนาซอฟต์แวร์แบบที่สามารถกำหนดทุกอย่างเองได้ไว้ใช้เฉพาะธุรกิจตัวเอง
              จึงเป็นอีกหนึ่งทางเลือกที่สำคัญสำหรับธุรกิจที่มุ่งหวังในการเติบโตอย่างมีเสถียรภาพ
            </p>
            <p className='text-center'>
              การพัฒนาซอฟต์แวร์แบบตามสั่ง (Custom Software Development) หรือซอฟต์แวร์แบบกำหนดเองนั้น
              มักมีวัตุถุประสงค์มาจากต้องการแก้ปัญหา ต้องการลดขั้นตอน ต้องการลดต้นทุน
              หรือแม้กระทั่งการเพิ่มประสิทธิภาพในการทำงานและการดำเนินธุกิจ
              และต้องมีเอกลักษณ์เฉพาะธุรกิจนั้นเอง
              จึงเป็นเหตุผลที่ว่าการพัฒนาซอฟต์แวร์ตามสั่งหรือซอฟต์แวร์แบบกำหนดได้เองนี้
              ทีมพัฒนาจะต้องนำกระบวนการการทำงานต่าง ๆ ไปอยู่ในซอฟต์แวร์ให้ได้
              ต้องตอบโจทย์กับการใช้งานและสามารถรับมือกับผู้ใช้งานที่หลากหลายได้เป็นอย่างดีรวมถึงสามารถวางแผนในการพัฒนาหรือปรับเปลี่ยนในแบบระยะยาวได้
              เพื่อตอบสนองความต้องการของธุรกิจและเทคโนโลยีใหม่ ๆ
            </p>
            <p className='text-center'>
              อย่าปล่อยให้ซอฟต์แวร์แบบสำเร็จที่มีอยู่ทั่วไปเป็นตัวกำหนดอนาคตของธุรกิจ
              จงกำหนดความเติบโตของธุรกิจด้วยตัวคุณเอง และพวกเรา ทวิน ซินเนอร์จี้
              ทีมพัฒนามืออาชีพที่มีความเชี่ยวชาญสูงและมีประสบการณ์ในการพัฒนามากกว่า 12 ปี
              พร้อมที่จะสนับสนุนและสร้างสรรค์ผลงานที่ตอบโจทย์และมีคุณภาพ ให้กับธุรกิจของคุณ
              เพื่อบรรลุทุก ๆ เป้าหมายที่คุณกำหนดไว้
            </p>
            <div className='text-center'>
              <Button
                htmlType='button'
                className='btn-neutral'
                onClick={() => Router.push('/contact-service')}
              >
                คุยกับผู้เชี่ยวชาญ
              </Button>
            </div>
          </>
        }
      />
      <div className='pb-24 lg:pb-0 xl:pt-44'>
        <div className='container mx-auto space-y-8 px-4 lg:pt-44 xl:pt-0'>
          <TitleShadow
            prologue='เหตุผล'
            colorPrologue='rgba(0,0,0,.08)'
            title={<>เหตุผลที่ต้องเป็นเรา</>}
            colorTitle='#000000'
            align='center'
          />
          <div className='grid grid-cols-1 gap-8 lg:grid-cols-2'>
            <Benefit
              className='border-none text-content-base'
              title={<>มีความเชี่ยวชาญพิเศษแบบเฉพาะทาง</>}
              subtitle='เรามีทีมพัฒนาที่เพรียบพร้อม'
              subTitlePosition='top'
              colorTitle='#000000'
              colorSubtitle='#000000'
              description={
                <p>
                  เรามีประสบการณ์และสามารถทำงานร่วมกับลูกค้าได้อย่างมืออาชีพ
                  ไม่ว่าความต้องการซับซ้อนเพียงแค่ไหนเรามั่นใจว่าทักษะและความรู้ที่เรามีจะสามารถทำให้มันผ่านไปได้
                </p>
              }
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <Benefit
              className='border-none text-content-base'
              title={<>และการบริหารโครงการที่มีศักยภาพ</>}
              subtitle='เราให้ความสำคัญในกระบวนการพัฒนา'
              subTitlePosition='top'
              colorTitle='#000000'
              colorSubtitle='#000000'
              description={
                <p>
                  ด้วยวิธี Agile เพื่อให้เกิดความยืดหยุ่นและสามารถปรับตัวได้อย่างรวดเร็ว เน้น Output
                  และ Feedback ตลอดการพัฒนา
                  เพื่อรองรับการปรับเปลี่ยนที่จำเป็นและมั่นใจว่าต้องตามความต้องการลูกค้าอย่างแท้จริง
                </p>
              }
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <div className='lg:col-span-2'>
              <ImgResponsive
                src='/images/service/middle_sevice_ecomerce.webp'
                alt='Twin Synergy service'
                sourceImgSm='/images/service/middle_sevice_ecomerce.webp'
                sourceImgMd='/images/service/middle_sevice_ecomerce.webp'
                loadingLazy
                className='mx-auto'
              />
            </div>
            <Benefit
              className='border-none text-content-base'
              title={<>ในการขยายของซอฟต์แวร์</>}
              subtitle='เราการออกแบบให้ซอฟต์แวร์โดยการคำนึงถึงความสามารถ'
              subTitlePosition='top'
              colorTitle='#000000'
              colorSubtitle='#000000'
              description={
                <>
                  <p>
                    และสามารถรองรับการเปลี่ยนแปลงของเทคโนโลยีในอนาคตได้
                    เพื่อให้ซอฟต์แวร์ที่สร้างนั้นสามารถอยู่คู่กับธุรกิจไปได้อย่างยาวนาน
                  </p>
                  <p>
                    เรามุ่งเน้นในการดูแลช่วยเหลือและบำรุงรักษาอย่างต่อเนื่อง
                    เพื่อให้มั่นใจว่าซอฟต์แวร์ที่พัฒนานั้นสามารถใช้งานได้อย่างดีและธุรกิจสามารถดำเนินไปได้อย่างราบรื่น
                  </p>
                </>
              }
              rootTitleStyle={{
                padding: '130px 0 50px',
              }}
            />
            <div className='px-4'>
              <h3 className='mb-16 text-3xl'>Experiences</h3>
              <div className=''>
                <ListBullet
                  list={[
                    'Content Management System (CMS)',
                    'Learning Management System (LMS)',
                    'Data Center Management System',
                    'Operation Management System',
                    'Sales Management System',
                    'RFID Document Tracking System',
                    'HR Management System',
                    'ETC.',
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-neutral py-28'>
        <div className='container mx-auto space-y-8 px-4'>
          <div className='grid grid-cols-1 items-center gap-4 text-white lg:grid-cols-2 xl:gap-8'>
            <ImgResponsive
              src='/images/service/service_contact.webp'
              alt='Twin Synergy service'
              sourceImgSm='/images/service/service_contact.webp'
              sourceImgMd='/images/service/service_contact.webp'
              loadingLazy
              className='mx-auto'
            />
            <div className='space-y-6'>
              <h2 className='xl:text-7xl'>
                เรามีทีมผู้เชี่ยวชาญในด้านการพัฒนาซอฟต์แวร์ตามสั่งโดยเฉพาะ
              </h2>
              <p className='font-bold xl:text-4xl'>
                คอยให้คำปรึกษาและคำแนะนำที่ดีให้กับคุณ
                โปรดลงทะเบียนเพื่อส่งข้อมูลและรายละเอียดความต้องการของคุณคร่าวๆมาที่เรา
              </p>
              <p>เราจะจัดผู้เชี่ยวชาญเพื่อประสานกับคุณโดยเร็ว</p>
              <Button
                htmlType='button'
                className='btn-warning'
                onClick={() => Router.push('/contact')}
              >
                ลงทะเบียนขอคำปรึกษา
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className='pt-24 lg:pt-44'>
        <div className='container mx-auto space-y-8 px-4 pb-14 xl:pt-0'>
          <TitleShadow
            prologue='ผลงาน'
            colorPrologue='rgba(0,0,0,.08)'
            title={<>ผลงานของเรา</>}
            colorTitle='#000000'
            align='center'
          />
        </div>
        <div className='grid grid-cols-2 lg:grid-cols-4'>
          <PortfolioItem
            title='Ice Factory App'
            categories='Application'
            serviceImg='/images/service/other/Ice_Factory_App.webp'
            serviceBg='#FFCA64'
          />
          <PortfolioItem
            title='Indorama'
            categories='website'
            serviceImg='/images/service/other/Indorama.webp'
            serviceBg='#FFCA64'
          />
          <PortfolioItem
            title='B grimm'
            categories='website'
            serviceImg='/images/service/other/B_Grim.webp'
            serviceBg='#FFCA64'
          />
        </div>
        <div className='bg-neutral text-center'>
          <Link
            className='flex items-center justify-center py-4 font-light text-white'
            href='/portfolio'
          >
            ดูโปรเจกต์ทั้งหมด <FaArrowRight className='ml-2' size={14} />
          </Link>
        </div>
        <div className='warranty grid grid-cols-2 lg:grid-cols-5'>
          <WarrantyItem
            content={
              <>
                Warrantee Source
                <br />
                code 1 year
              </>
            }
            serviceImg='/images/service/warratee.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content={
              <>
                Support team (8/7)
                <br />6 month
              </>
            }
            serviceImg='/images/service/support_team.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content='Free MA 6 month'
            serviceImg='/images/service/free_MA.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content={
              <>
                Free consultant
                <br />
                Forever
              </>
            }
            serviceImg='/images/service/free_consultant.webp'
            serviceBg='#F7F8F9'
          />
          <WarrantyItem
            content={
              <>
                Free integration
                <br />
                service fee
              </>
            }
            serviceImg='/images/service/free_integration.webp'
            serviceBg='#F7F8F9'
          />
        </div>
      </div>
      <div className='bg-author-base py-24'>
        <div className='container mx-auto space-y-8'>
          <ServiceGetInTouch
            content='"พวกเราคือทีมพัฒนามืออาชีพที่มีความเชี่ยวชาญและสามารถทำงานร่วมกับทุกคนได้อย่างมีประสิทธิภาพ"'
            secondContent={<p className='mt-8'>โปรดไว้ใจเราเป็นทีมพัฒนาให้กับซอฟต์แวร์ของคุณ</p>}
          />
        </div>
      </div>
      <div className='section-service pt-24 lg:pt-44'>
        <div className='container mx-auto space-y-8 px-4 pb-14 xl:pt-0'>
          <TitleShadow
            prologue='บริการ'
            colorPrologue='rgba(0,0,0,.08)'
            title='บริการอื่น ๆ'
            colorTitle='#000000'
            align='center'
          />
        </div>
        <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4'>
          <ServiceItem
            prologue='01'
            title='พัฒนาเว็บไซต์'
            serviceImg='/images/service/service-01.webp'
            serviceBg='#06B7B7'
            serviceUrl='website-development'
          />
          <ServiceItem
            prologue='02'
            title='พัฒนาแอปพลิเคชั่นมือถือ'
            serviceImg='/images/service/service-02.webp'
            serviceBg='#1990FF'
            serviceUrl='mobile-application-development'
          />
          <ServiceItem
            prologue='03'
            title='ออกแบบเว็บไซต์'
            serviceImg='/images/service/service-03.webp'
            serviceBg='#FFCA64'
            serviceUrl='website-design'
          />
          <ServiceItem
            prologue='04'
            title='เว็บไซต์สำหรับธุรกิจ SME'
            serviceImg='/images/service/service-04.webp'
            serviceBg='#FFAC79'
            serviceUrl='sme-website-development'
          />
          <ServiceItem
            prologue='05'
            title='ออกแบบและพัฒนา Line OA'
            serviceImg='/images/service/service-05.webp'
            serviceBg='#00BE00'
            serviceUrl='line-oa-development'
          />
          <ServiceItem
            prologue='06'
            title='พัฒนาซอฟต์แวร์ตามกำหนด'
            serviceImg='/images/service/service-06.webp'
            serviceBg='#FF7D7D'
            serviceUrl='custom-software-development'
          />
          <ServiceItem
            prologue='07'
            title='เพิ่มความปลอดภัย'
            serviceImg='/images/service/no-service.webp'
            serviceBg='#B577E5'
            noLink
          />
          <ServiceItem
            prologue='08'
            title='ดูแลบำรุงรักษาเว็บไซต์'
            serviceImg='/images/service/no-service.webp'
            serviceBg='#484848'
            noLink
          />
        </div>
      </div>
    </LayoutDefault>
  )
}

export default ServicePage
